import React, { createRef, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
const ANSWER_PADDING = 42;
function expand(answerContainer, answerCopy) {
    answerContainer.style.height = `${answerCopy.offsetHeight +
        ANSWER_PADDING}px`;
}
function collapse(answerContainer) {
    answerContainer.style.height = "0px";
}
export function AccordionItem({ id, title, content, open }) {
    const [isOpen, setIsOpen] = useState(open || false);
    const answerContainerRef = createRef();
    const answerCopyRef = createRef();
    useEffect(() => {
        const answerContainer = answerContainerRef.current;
        const answerCopy = answerCopyRef.current;
        if (!isOpen) {
            collapse(answerContainer);
        }
        else {
            expand(answerContainer, answerCopy);
        }
    }, [isOpen, answerContainerRef, answerCopyRef]);
    const className = isOpen ? "--open" : "--closed";
    return (React.createElement("li", null,
        React.createElement("div", { id: id, className: `question-wrapper ${className || ""}` },
            React.createElement("div", { className: "question", role: "button", "aria-expanded": isOpen, "aria-controls": `question--${id}`, 
                // tslint:disable-next-line:react-this-binding-issue
                onClick: () => setIsOpen(!isOpen) },
                React.createElement("p", { className: "question-copy" }, title),
                React.createElement("img", { className: "faq-arrow", src: "assets/faq_arrow.svg", alt: "Up/Down Arrow" })),
            React.createElement("div", { id: `question--${id}`, className: "answer", "aria-hidden": !isOpen, ref: answerContainerRef },
                React.createElement("div", { className: "answer-copy", ref: answerCopyRef }, typeof content === "string" ? (React.createElement(ReactMarkdown, { source: content, escapeHtml: false, linkTarget: "_blank" })) : (content))))));
}
//# sourceMappingURL=AccordionItem.js.map